import { useState } from "react";
import { Instagram, Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { CartDrawer } from "@/components/CartDrawer";
import logoImg from "@/assets/logo-pawtrait.webp";

const NAV_LINKS = [
  { href: "/", label: "Inicio" },
  { href: "/merch-digital", label: "Merch" },
  { href: "/hecho-a-mano", label: "Retratos" },
  { href: "/#galeria", label: "Galería" },
  { href: "/#proceso", label: "Proceso" },
  { href: "/faq", label: "FAQ" },
  { href: "/#contacto", label: "Contacto" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-9 sm:top-9 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      {/* Mobile: logo centered & large (Wix-style) */}
      <div className="lg:hidden">
        <div className="relative flex items-center justify-center px-4 py-3">
          <a href="/" className="flex items-center justify-center">
            <img
              src={logoImg}
              alt="Pawtrait — Arte de mascotas personalizado"
              className="h-20 sm:h-24 w-auto object-contain"
            />
          </a>

          {/* Right-side controls absolutely positioned so logo stays centered */}
          <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1">
            <CartDrawer />
            <button
              type="button"
              onClick={() => setIsOpen((v) => !v)}
              className="p-2 rounded-full text-foreground/70 hover:text-secondary hover:bg-secondary/10 transition-all duration-200"
              aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
              aria-expanded={isOpen}
            >
              {isOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

      </div>

      {/* Desktop layout */}
      <div className="hidden lg:flex max-w-7xl mx-auto px-6 py-3 items-center justify-between gap-2">
        <a href="/" className="flex items-center shrink-0">
          <img
            src={logoImg}
            alt="Pawtrait"
            className="h-20 w-auto object-contain"
          />
        </a>

        <div className="flex items-center gap-10 text-sm font-medium text-foreground/70">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="hover:text-secondary transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3 shrink-0">
          <a
            href="https://www.instagram.com/pawtrait.pop"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex p-2 rounded-full text-foreground/60 hover:text-secondary hover:bg-secondary/10 transition-all duration-200"
            aria-label="Instagram"
          >
            <Instagram size={20} />
          </a>
          <CartDrawer />
          <Link
            to="/pedir-retrato"
            className="bg-primary text-primary-foreground px-5 py-2.5 rounded-full font-medium text-sm hover:opacity-90 transition-opacity duration-200 whitespace-nowrap"
          >
            Crear el mío 🐾
          </Link>
        </div>
      </div>

      {/* Mobile/Tablet menu panel */}
      {isOpen && (
        <div className="lg:hidden border-t border-border bg-background/95 backdrop-blur-md">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col gap-1 font-body text-base font-medium text-foreground/80">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsOpen(false)}
                className="px-3 py-3 rounded-lg hover:bg-secondary/10 hover:text-secondary transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://www.instagram.com/pawtrait.pop"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsOpen(false)}
              className="flex items-center gap-2 px-3 py-3 rounded-lg hover:bg-secondary/10 hover:text-secondary transition-colors duration-200"
            >
              <Instagram size={18} /> Instagram
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
